import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: {
        adminName: null,
        stats: null,
        revenueBySource: null,
        revenueBySourceTotal: null,
        funnel: null,
        funnelConversion: 0,
        revenueTrend: null,
        userGrowth: null,
        listingsOverview: null,
        recentActivities: null,
        needsAttention: null,
        navBadges: null,
    },
    reducers: {
        doGetOverviewSuccess: (state, action) => {
            const p = action.payload;
            state.adminName = p.admin_name;
            state.stats = p.stats;
            state.revenueBySource = p.revenue_by_source;
            state.revenueBySourceTotal = p.revenue_by_source_total;
            state.funnel = p.funnel;
            state.funnelConversion = p.funnel_conversion;
            state.revenueTrend = p.revenue_trend;
            state.userGrowth = p.user_growth;
            state.listingsOverview = p.listings_overview;
            state.recentActivities = p.recent_activities;
            state.needsAttention = p.needs_attention;
        },
        doGetOverviewFail: (state) => {
            state.adminName = null;
            state.stats = null;
            state.revenueBySource = null;
            state.revenueBySourceTotal = null;
            state.funnel = null;
            state.funnelConversion = 0;
            state.revenueTrend = null;
            state.userGrowth = null;
            state.listingsOverview = null;
            state.recentActivities = null;
            state.needsAttention = null;
        },
        doGetNavBadgesSuccess: (state, action) => {
            state.navBadges = action.payload?.data || action.payload || null;
        },
        // Badges are decoration — on failure just drop them rather than blanking the nav.
        doGetNavBadgesFail: (state) => { state.navBadges = null; },
    },
});

export const doGetDashboardOverview = () => async (dispatch) => {
    try {
        const response = await axios.get("/api/admin/dashboard/overview");
        dispatch(doGetOverviewSuccess(response.data));
    } catch (error) {
        dispatch(doGetOverviewFail(error.response));
    }
};

export const doGetNavBadges = () => async (dispatch) => {
    try {
        const response = await axios.get("/api/admin/dashboard/nav-badges");
        dispatch(doGetNavBadgesSuccess(response.data));
    } catch (error) {
        dispatch(doGetNavBadgesFail());
    }
};

export const {
    doGetOverviewSuccess, doGetOverviewFail,
    doGetNavBadgesSuccess, doGetNavBadgesFail,
} = dashboardSlice.actions;

export const getDashboardAdminName = (state) => state.dashboard?.adminName;
export const getDashboardStats = (state) => state.dashboard?.stats;
export const getDashboardRevenueBySource = (state) => state.dashboard?.revenueBySource;
export const getDashboardRevenueBySourceTotal = (state) => state.dashboard?.revenueBySourceTotal;
export const getDashboardFunnel = (state) => state.dashboard?.funnel;
export const getDashboardFunnelConversion = (state) => state.dashboard?.funnelConversion;
export const getDashboardRevenueTrend = (state) => state.dashboard?.revenueTrend;
export const getDashboardUserGrowth = (state) => state.dashboard?.userGrowth;
export const getDashboardListingsOverview = (state) => state.dashboard?.listingsOverview;
export const getDashboardRecentActivities = (state) => state.dashboard?.recentActivities;
export const getDashboardNeedsAttention = (state) => state.dashboard?.needsAttention;
export const getNavBadges = (state) => state.dashboard?.navBadges;

export default dashboardSlice.reducer;
